<template>
  <div class="px-4 mb-4 bg-white rounded shadow-sm">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>
  
  <script>
import { Chart, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import zoomPlugin from "chartjs-plugin-zoom";

Chart.register(...registerables, ChartDataLabels, zoomPlugin);

export default {
  name: "PhotoStatsChart",
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    data: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.renderChart();
        });
      },
    },
  },
  methods: {
    renderChart() {
      if (!this.$refs.chartCanvas) return;
      if (this.chart) this.chart.destroy();

      const labels = this.data.map((item) => item.grouped_date || item.date);
      const photoCounts = this.data.map((item) => parseInt(item.num));
      const revenueValues = this.data.map((item) => parseFloat(item.money));

      const ctx = this.$refs.chartCanvas.getContext("2d");

      this.chart = new Chart(ctx, {
        type: "line",
        data: {
          labels,
          datasets: [
            {
              label: "Photos",
              data: photoCounts,
              borderColor: "#0d6efd",
              backgroundColor: "rgba(13, 110, 253, 0.2)",
              fill: true,
              tension: 0.3,
              pointRadius: 3,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            tooltip: {
              callbacks: {
                label: (ctx) => {
                  const index = ctx.dataIndex;
                  const revenue = revenueValues[index]?.toFixed(2) ?? "0.00";
                  return [
                    `Photos: ${photoCounts[index]}`,
                    `Revenue: ₾ ${revenue}`,
                  ];
                },
              },
            },
            datalabels: {
              color: "#000",
              backgroundColor: "#ffffff",
              borderColor: "#0d6efd",
              borderWidth: 1,
              borderRadius: 4,
              padding: {
                top: 2,
                right: 4,
                bottom: 2,
                left: 4,
              },
              font: {
                weight: "bold",
                size: 10,
              },
              anchor: "end",
              align: "top",
              formatter: (value, context) => {
                const index = context.dataIndex;
                const revenue = revenueValues[index]?.toFixed(2) ?? "0.00";
                return `₾ ${revenue}`;
              },
            },
            legend: {
              display: true,
              position: "top",
            },
            zoom: {
              pan: {
                enabled: true,
                mode: "x",
                modifierKey: "ctrl",
              },
              zoom: {
                wheel: {
                  enabled: true,
                  modifierKey: "shift",
                },
                pinch: {
                  enabled: true,
                },
                mode: "x",
              },
              limits: {
                x: {
                  minRange: 1,
                },
              },
            },
          },
          scales: {
            x: {
              title: {
                display: true,
                text: "Date",
              },
              ticks: {
                maxRotation: 45,
                minRotation: 45,
              },
            },
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: "Photos",
              },
            },
          },
        },
        plugins: [ChartDataLabels],
      });
    },
    updateChartManually() {
      this.$nextTick(() => this.renderChart());
    },
    resetZoom() {
      if (this.chart) {
        this.chart.resetZoom();
      }
    },
  },
  beforeUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
};
</script>
  